import api from "../../api/api";

export const getPlans = () => api.get("/subscription/getPlans");

/** Owner-only — Body: { subscription_id } */
export const activateSubscription = (body) =>
  api.post("/subscription/activateSubscription", body);

export const getNextBillingPayment = () =>
  api.get("/subscription/getNextBillingPayment");

export const getSubscriptionPayments = () =>
  api.get("/subscription/getPayment");

/** Owner-only — Body: { subscription_id } */
export const terminateSubscription = (body) =>
  api.post("/subscription/terminateSubscription", body);

/** Owner-only — Body: { subscription_id, plan_id } */
export const changePlan = (body) => api.post("/subscription/changePlan", body);

/** Owner-only — Body: { subscription_id } */
export const revertPendingPlan = (body) =>
  api.post("/subscription/revertPendingPlan", body);

/** Owner-only — Body: { subscription_id } */
export const reactivateSubscription = (body) =>
  api.post("/subscription/reactivateSubscription", body);

/** Owner-only - Body: { subscription_id } */
export const chargeSavedCard = (body) =>
  api.post("/payment/chargeSavedCard", body);

/** Authenticated tenant; server resolves subscription from the current user. */
export const getSubscriptionStatus = () =>
  api.get("/subscription/getSubscriptionStatus");

export const getSubscriptionChangeLog = () =>
  api.get("/subscription/getSubscriptionChangeLog");

/** Authenticated tenant; no body needed. */
export const syncPaymentStatus = () =>
  api.post("/subscription/syncPaymentStatus");
